/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const SquareCheckBig = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5" }],
    ["path", { d: "m9 11 3 3L22 4" }]
  ]
];

export { SquareCheckBig as default };
//# sourceMappingURL=square-check-big.js.map
